module.exports = __webpack_public_path__ + "img/TinyTAN_Butter02.61da8ae7.png";